import React, { PropsWithChildren } from "react";
import { Grid, Typography, useTheme } from "@mui/material";
import { DKGrid } from "./DKGrid";
import { isEmpty } from "../../helpers/utilsTS";

type TitledGridProps = {
  title?: string;
};

export const TitledGrid = (props: PropsWithChildren<TitledGridProps>) => {
  const { title, children } = props;

  const theme = useTheme();

  return (
    <DKGrid>
      {!isEmpty(title) && (
        <Grid item xs={12} marginBottom={"10px"}>
          <Typography
            variant={"subtitle1"}
            sx={{
              fontWeight: "bold",
              color: theme.palette.tertiary.darker,
            }}
          >
            {title}
          </Typography>
        </Grid>
      )}
      {children}
    </DKGrid>
  );
};
